import React from 'react'

export const Footer = () => {
    return (
        <div className="footer">
            <p>Inspired by <a href="https://poeltl.dunk.town/" 
                              target="_blank" 
                              rel="noopener noreferrer">Poeltl</a></p>
        </div>
    )
}